module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-mv-slider-arrows-icon-prev-2b3ea948661308a6e83cfacd86835ad3.svg";